import { ArrowLink, Img } from '@app/components';
import { SiteMap } from '@app/constants';
import { useEnhancedTranslation } from '@app/hooks';
import { tMap } from '@app/i18n';
import { CardLinkProps, TBrandCard } from '@app/models';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import './brand-card.scss';

type BrandCardProps = CardLinkProps<TBrandCard> & {
  imageProp?: 'image' | 'cover';
};

export const BrandCard = (props: BrandCardProps): JSX.Element => {
  const { link, name, logo, floor, cornerId, className, pictureClassName, imageProp = 'image' } = props;
  const { tRoot } = useEnhancedTranslation({ keyPrefix: 'brands' });

  return (
    <figure className={cx(className, 'brand-card')}>
      <picture className={cx(pictureClassName, 'brand-card__picture', 'brand-card--hover')}>
        <Link to={link} className="brand-card__link">
          {/* eslint-disable-next-line react/destructuring-assignment */}
          <Img src={props[imageProp]?.url} className="brand-card__image" alt={tMap(name)} />
        </Link>
        {logo && (
          <picture className="brand-card__logo">
            <Img className="brand-card__logo-image" src={logo?.url} alt={tMap(name)} />
          </picture>
        )}
        {false && Number.isInteger(floor) && (
          <ArrowLink size="small" className="brand-card__floor-link" to={`${SiteMap.MAP}/${floor}/${cornerId || ''}`}>
            {tRoot('floors.floorNum', { floor })}
          </ArrowLink>
        )}
      </picture>
      <figcaption className="brand-card__caption">{tMap(name)}</figcaption>
    </figure>
  );
};
